import { useRef } from "react";
import CropImage from "../CropImage";
import { DrawerAndModal } from "../DrawerAndModal";
import { useBoundStore } from "@/app/store";
import { useShallow } from "zustand/shallow";
import { Button } from "@heroui/react";

interface CropModalProps {
  id: string;
  externalState: {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
  };
  imgSrc: string | ArrayBuffer | null;
  onCrop: (image: Blob | null) => Promise<void> | void;
}

export function ManageImageCrop({ id, imgSrc, externalState, onCrop }: CropModalProps) {
  const blobRef = useRef<Blob | null>(null);
  const deviceType = useBoundStore(useShallow((state) => state.device.type));

  const handleSave = () => {
    onCrop(blobRef.current);
  };

  return (
    <DrawerAndModal
      id={`${id}-crop`}
      closeLabel="Cancel"
      confirmLabel="Done"
      onConfirm={handleSave}
      title="Crop image"
      externalState={externalState}
    >
      <CropImage onChange={(blob) => (blobRef.current = blob)} imgSrc={imgSrc} />
      {deviceType === "mobile" && (
        <div className="flex gap-2 pt-2">
          <Button variant="flat" fullWidth onPress={() => externalState.onOpenChange(false)}>
            Cancel
          </Button>
          <Button color="primary" fullWidth onPress={handleSave}>
            Save
          </Button>
        </div>
      )}
    </DrawerAndModal>
  );
}
